<template>
  <form @submit.prevent="save" class="w-m-content" v-if="!loading && !errors && !success">
    <div class="w-m-header">
      <div class="flex">
        <p class="font-14 font-bold no-margin col-grow" style="color: #293e52">Template do Sistema</p>
        <div class="">
          <u-btn size="sm" flat label="Variáveis" icon="eye" icon-type="fa" @click="$refs.vars.show()" />
        </div>
      </div>
      <!--<div class="m-t-xs font-13 text-grey-7" style="color: #748396; padding-right: 20px; line-height: 1">Esta seção
        autoriza uma pessoa a acessar o software, com suas respectivas permissões.
      </div>-->
    </div>
    <div class="w-m-body e-input-modern flex">
      <div style="min-height: 400px" class="flex column w-full">
        <show-all ref="vars" />
        <e-row mr>
          <e-col style="max-width: 300px">
            <e-row class="m-b-sm font-bold">
              Nome do template:
            </e-row>
            <e-row class="m-b-sm">
              <e-col>
                <erp-input autofocus simple-border required placeholder="Ex.: Boas Vindas Arrematante após cadastro"
                           v-model="model.name" />
              </e-col>
            </e-row>
          </e-col>
          <e-col style="max-width: 20%">
            <e-row class="m-b-sm font-bold">
              Código:
            </e-row>
            <e-row class="m-b-sm">
              <e-col>
                <erp-input simple-border required placeholder="Referência do template"
                           v-model="model.code" />
              </e-col>
            </e-row>
          </e-col>
          <e-col>
            <e-row class="m-b-sm font-bold">
              Descrição sobre o template:
            </e-row>
            <e-row class="m-b-sm">
              <e-col>
                <erp-input simple-border required placeholder="Ex.: Tiago Felipe" v-model="model.description" />
              </e-col>
            </e-row>
          </e-col>
        </e-row>

        <e-row mr>
          <e-col>
            <e-row class="m-b-sm font-bold">
              Assunto/Título:
            </e-row>
            <e-row class="m-b-sm">
              <e-col>
                <erp-input autofocus simple-border required placeholder="Ex.: Olá {ARREMATANTE.NOME}, seu cadastro foi aprovado!"
                           v-model="model.subject" />
              </e-col>
            </e-row>
          </e-col>
          <e-col style="max-width: 100px" class="flex flex-center">
            <label class="flex items-center m-t-sm" style="max-width: 100px">
              <u-checkbox v-model="model.active" />
              <span class="font-13 m-l-xs">Ativo</span></label>
          </e-col>
        </e-row>

        <e-row v-show="!source" class="m-b-sm m-t col-grow flex">
          <e-col class="flex col-grow column">
            <div class="m-b font-bold w-full flex-zero">Conteúdo do template:</div>
            <u-editor class="editor-flex" v-model="model.template" :toolbar="[
        ['bold', 'italic', 'strike', 'underline', 'subscript', 'superscript'],
        ['token', 'hr', 'link', 'custom_btn'],
        ['print', 'fullscreen'],
        [
          {
            // label: $uloc.i18n.editor.formatting,
            icon: $uloc.icon.editor.formatting,
            list: 'no-icons',
            options: ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'code']
          },
          {
            // label: $uloc.i18n.editor.fontSize,
            icon: $uloc.icon.editor.fontSize,
            fixedLabel: true,
            fixedIcon: true,
            list: 'no-icons',
            options: ['size-1', 'size-2', 'size-3', 'size-4', 'size-5', 'size-6', 'size-7']
          },
          {
            label: 'Fonte',
            icon: $uloc.icon.editor.font,
            fixedLabel: true,
            fixedIcon: true,
            list: 'no-icons',
            options: ['default_font', 'arial', 'arial_black', 'comic_sans', 'courier_new', 'impact', 'lucida_grande', 'times_new_roman', 'verdana']
          },
          'removeFormat'
        ],
        ['quote', 'unordered', 'ordered', 'outdent', 'indent'],
        [
          {
            // label: $uloc.i18n.editor.align,
            icon: $uloc.icon.editor.align,
            fixedLabel: true,
            list: 'only-icons',
            options: ['left', 'center', 'right', 'justify']
          },
          {
            // label: $uloc.i18n.editor.align,
            icon: $uloc.icon.editor.align,
            fixedLabel: true,
            options: ['left', 'center', 'right', 'justify']
          }
        ],
        ['undo', 'redo']
      ]"
                      :fonts="{
        arial: 'Arial',
        arial_black: 'Arial Black',
        comic_sans: 'Comic Sans MS',
        courier_new: 'Courier New',
        impact: 'Impact',
        lucida_grande: 'Lucida Grande',
        times_new_roman: 'Times New Roman',
        verdana: 'Verdana'
      }" />
          </e-col>
        </e-row>
        <e-row v-show="source">
          <e-col>
            <textarea class="w-full wrapper-sm" rows="10" v-model="model.template" />
          </e-col>
        </e-row>
        <div class="flex items-center">
          <u-toggle v-model="source" class="m-r-sm" />
          Editar código fonte
        </div>

        <e-row class="m-t">
          <e-col>
            <div class="m-b font-bold w-full flex-zero">Versão em texto puro (caso se aplique):</div>
            <textarea class="w-full wrapper-sm" rows="5" v-model="model.pureText" />
          </e-col>
        </e-row>


      </div>
    </div>
    <div class="w-m-footer text-right">
      <u-btn @click="excluir" v-if="id && !model.interno" label="Excluir" no-caps color="negative"
             class="b-radius-3px pull-left" />
      <u-btn type="submit" :label="id ? 'Atualizar' : 'Cadastrar'" :disable="!ready" no-caps
             :color="ready ? 'primary' : 'blue-grey-2'"
             class="b-radius-3px" />
    </div>
  </form>
  <window-success v-else-if="success">
    <div class="text-center">
      <u-icon name="check-circle" color="positive" type="fa" icon-style="solid" class="success-circle-140" />
    </div>
    <h5 class="m-t">Template registrado com sucesso!</h5>
    <div class="m-t text-blue-grey-7">
      Ela poderá ser utilizada em todo o sistema de templates/documentos.
    </div>
    <div class="text-center m-t">
      <timer-close-window ref="timer" @endREMOVED="$uloc.window.close($root.wid)" />
    </div>
  </window-success>
  <window-loading :errors="errors" :status="status" v-else />
</template>

<script>
import ERow from '../../../layout/components/Row'
import {ErpInput} from 'uloc-vue-plugin-erp'
import ECol from '../../../layout/components/Col'
import {UCheckbox, UEditor, UToggle} from 'uloc-vue'
import WindowSuccess from '../../../layout/window/Success'
import TimerCloseWindow from '../../../layout/window/TimerClose'
import WindowLoading from '../../../layout/window/Loading'
import {
  newTemplate as create,
  updateTemplate as update,
  find,
  deleteTemplate
} from '../../../../domain/templates/services'
import ShowAll from '../../../variaveis/components/showAll'

let mock = {
  id: null,
  code: null,
  name: null,
  description: null,
  subject: null,
  template: '',
  pureText: null,
  active: true
}

export default {
  name: 'TemplateWindowModern',
  components: {
    ShowAll,
    WindowLoading, TimerCloseWindow, WindowSuccess, ECol, ERow, ErpInput, UCheckbox, UEditor, UToggle},
  props: ['props', 'id'],
  data () {
    return {
      model: JSON.parse(JSON.stringify(mock)),
      loading: !!this.id,
      errors: null,
      success: false,
      status: null,
      source: false
    }
  },
  mounted () {
    this.id && this.load()
  },
  computed: {
    mock () {
      return mock
    },
    ready () {
      let model = this.model
      if (String(model.name).length > 2 && model.template) {
        return true
      }
      return false
    }
  },
  methods: {
    load () {
      find(this.id)
        .then(response => {
          this.model = response.data
          this.loading = false
        })
        .catch(error => {
          this.alertApiError(error)
          this.loading = false
        })
    },
    excluir () {
      this.$uloc.dialog({
        title: `Tem certeza que deseja excluir este template?`,
        message: 'Digite EXCLUIR e clique para confirmar:',
        prompt: {
          model: '',
          type: 'text' // optional
        },
        cancel: true,
        color: 'negative'
      }).then(data => {
        if (data.toUpperCase() !== 'EXCLUIR') {
          this.$uloc.notify({
            color: 'negative',
            message: `Você não confirmou a operação. Exclusão não efetuada.`
          })
          return
        }
        this.$uloc.notify({
          color: 'negative',
          message: `Excluindo template...`
        })
        deleteTemplate(this.id)
          .then(response => {
            this.$uloc.notify({
              color: 'positive',
              message: `Template deletado com sucesso!`
            })
            this.$uloc.window.emit(this.$root.wid, 'created', this.props)
            this.$uloc.window.close(this.$root.wid)
          })
          .catch(error => {
            this.alertApiError(error)
          })
      }).catch(() => {
      })
    },
    save () {
      console.log('Save')
      this.loading = true

      let data = this.model

      let method = this.id ? (data) => update(this.id, data) : create
      method(data)
        .then(({data}) => {
          this.success = true
          Object.assign(this.model, data)
          this.$nextTick(() => {
            this.$uloc.window.emit(this.$root.wid, 'created', this.props)
            this.$refs.timer.start()
            this.load()
            window.setTimeout(() => {
              this.loading = false
              this.success = false
              this.afterUpdate = false
            }, 3000)
          })
        })
        .catch(error => {
          this.success = false
          this.errorMessage = error.data.message
          // this.errors = this.systemError(error)
          this.$nextTick(() => {
            this.loading = false
            this.alertApiError(error)
            // this.error = true
          })
        })
    }
  }
}
</script>
